import {
  InMemoryHeader,
  InMemoryString,
  InMemoryDecimal,
  InMemoryInteger,
} from "pbas-vue-components";

import { i18n } from '@/plugins/i18n';

function getHeaders(languages) {
  const headers = [
    new InMemoryHeader({
      type: new InMemoryString("Identifier"),
      visible: false,
      isIdentifier: true,
      allowVisibilityChange: false,
    }),
    new InMemoryHeader({
      title: "headers.memberdependants.id",
      type: new InMemoryString("Id"),
      sortable: true,
      visible: true,
      searchable: true,
      allowVisibilityChange: true,
    }),
    new InMemoryHeader({
      title: "globals.order",
      type: new InMemoryDecimal("Order", {
        getString: (item) => {
          return item.Order.toString();
        },
      }),
      sortable: true,
      visible: true,
      searchable: true,
      allowVisibilityChange: true,
    }),
    new InMemoryHeader({
      title: "headers.dashboard_items.class_name",
      type: new InMemoryString("Name", {
        getString: (item) => {
          if (item.Name === undefined || item.Name === null) {
            return "";
          }
          return i18n.t("enums." + item.Name);
        },
      }),
      sortable: true,
      visible: true,
      searchable: true,
      allowVisibilityChange: true,
    }),
    new InMemoryHeader({
      title: "headers.member_files.size",
      type: new InMemoryInteger("Size"),
      sortable: true,
      visible: true,
      searchable: true,
      allowVisibilityChange: true,
    }),
    new InMemoryHeader({
      title: "globals.type",
      type: new InMemoryString("Type"),
      sortable: true,
      visible: true,
      searchable: true,
      allowVisibilityChange: true,
    }),
    new InMemoryHeader({
      title: "headers.member_information_items.panels",
      type: new InMemoryString("Panels", {
        getString: (item) => {
          if (!item) return "";
          if (!item.Panels) return "";
          return item.Panels.map((o) => {
            let str = "(";
            for (const lang of languages) {
              str += `${lang.language}: ${o["Title" + lang.language.toUpperCase()]} `;
            }
            return str;
          }).join(", ");
        },
        getHtml: (item, type) => {
          return (
            "<div style='word-wrap: break-word; white-space: pre-wrap; max-width: 200px'>" +
            type.getString(item, type) +
            "</div>"
          );
        },
      }),
      sortable: true,
      version: 1,
    })
  ];
  return headers;
}
export default getHeaders;
